import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const useDynamicFont = () => {
    const { i18n } = useTranslation();
    const lang = i18n.language;

    useEffect(() => {
        const fontId = "lang-font";

        // Remove old font
        const existing = document.getElementById(fontId);
        if (existing) existing.remove();

        const fontUrl = `/locales/${lang}/font-${lang}.woff2`;

        const style = document.createElement("style");
        style.id = fontId;
        style.innerHTML = `
      @font-face {
        font-family: 'LangFont';
        src: url('${fontUrl}') format('woff2');
        font-weight: normal;
        font-style: normal;
      }

      html, body, *, .ant-typography, .ant-btn, .ant-input {
        font-family: 'LangFont', sans-serif !important;
      }
    `;
        document.head.appendChild(style);
    }, [lang]);
};
